module.exports = __webpack_public_path__ + "img/portfolio-screenshot.b8840263.png";